import { Chip } from "@mui/material";
import { DOCUMENT_STATUS_CONFIG } from "../../constants/documentStatus";
import { useAppTranslation } from "../../hooks/useAppTranslation";

interface Props {
  status?: string | null;
}

export default function DocumentStatusChip({ status }: Props) {
  const { t } = useAppTranslation("statuses");

  const normalized =
    typeof status === "string" && status.trim()
      ? status
      : "Draft";

  const config =
    DOCUMENT_STATUS_CONFIG[normalized] ?? {
      color: "default" as const,
    };

  return (
    <Chip
      size="small"
      label={t(normalized)}
      color={config.color}
      variant="outlined"
    />
  );
}